import { useDispatch } from "react-redux";
import { useMutation, useQueryClient } from "@tanstack/react-query"

import { editarConfiguracionNotificaciones } from "../services/notificaciones.service";

import { dangerNotification } from '../../../redux/slices/ui';

export const useEditarConfiguracionNotificaciones = (id) => {

    const dispatch = useDispatch();

    const queryClient = useQueryClient();

    const editarConfiguracionNotificacionesMutation = useMutation({
        mutationFn: editarConfiguracionNotificaciones,
        onSuccess: (configuracion, variables, context) => {
            queryClient.invalidateQueries({ queryKey: ['configuracionNotificaciones'], exact: false });
        },
        onError: (error, variables, context) => {
            variables.onComplete();
            dispatch(dangerNotification(error.msg.message));
        }
    });

    return {
        editarConfiguracionNotificacionesMutation,
    }
}